import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
  }
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  margin-top: 20px;

  span {
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary.vividCerulean};
  }

  hr {
    border: 1px solid ${({ theme }) => theme.colors.primary.vividCerulean};
    width: 100%;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Download = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;

  padding: 20px;
  width: 870px;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;

  margin-bottom: 20px;

  span {
    font-size: 16px;
  }
`;

export const QuotasWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  width: 70%;

  margin-bottom: 20px;

  ${media.lessThan("medium")`
    width: 100%;
    flex-wrap: wrap;
  `}
`;

export const QuotaColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;
  align-items: center;

  width: 100%;

  h3 {
    font-size: 14px;
  }
`;

export const Quota = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;
  align-items: center;

  width: 100%;

  span {
    font-size: 14px;
  }
`;

export const Uf = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Cities = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const City = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.black};

  display: flex;
  align-items: center;
  gap: 5px;
`;

export const File = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.primary.vividCerulean};
  border-radius: 5px;

  h2 {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.black};
  }
`;

export const FileInfos = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HideDownload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 10px;

  h2 {
    font-size: 32px;
    color: ${({ theme }) => theme.colors.neutral.black};
  }

  span {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.neutral.black};
  }

  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.neutral.white};

  position: fixed;
  top: 0;
  left: 0;

  z-index: 9999;
`;

export const DownloadButton = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  ${media.lessThan("medium")`
    display: none;
  `}
`;

/*
 * Cada botão de sessão vira âncora do badge. O `position: relative` fica aqui, e
 * não no Button: ele é do design-system e mexer nele afetaria toda a área admin.
 */
export const TabSlot = styled.div`
  position: relative;

  /* O Button preenche o slot para o grid seguir com colunas iguais. */
  button {
    width: 100%;
  }
`;

/*
 * Badge de pendências (05/09/2026). Mesma leitura do ponto vermelho do sino —
 * "há algo esperando por você" —, mas com o NÚMERO: aqui o admin decide em qual
 * sessão entrar, e "3" responde isso enquanto um ponto só diria "em alguma".
 *
 * Vermelho pelo token `feedbackState.critical`, que existe nos DOIS temas
 * (`feedback.error` só existe no comum e quebraria o admin).
 */
export const TabBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  z-index: 1;

  min-width: 20px;
  height: 20px;
  padding: 0 5px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
  color: ${({ theme }) => theme.colors.neutral.white};

  font-size: 11px;
  font-weight: 700;
  line-height: 1;
`;

export const Tabs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: 10px;

  margin-top: 30px;
`;
